// extracted by mini-css-extract-plugin
export default {"content":"MyOpinion_content__EHnUP","title":"MyOpinion_title__ht9GA","bg":"MyOpinion_bg__yMMp2","moveBtn":"MyOpinion_moveBtn__X1Yzf","btnText":"MyOpinion_btnText__9JqEL"};